import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=3c5ebf08"
import script from "./LegalInformation.vue?vue&type=script&lang=js"
export * from "./LegalInformation.vue?vue&type=script&lang=js"
import style0 from "./LegalInformation.vue?vue&type=style&index=0&id=3c5ebf08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports